/**
 * Transfer Patient Bed Page
 *
 * @author Agbonaye Osaru - osaru@sarutech.com
 */
import { Input, Component, ViewEncapsulation, Injector, PipeTransform, Pipe, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ToastController, LoadingController, ModalController, AlertController, Platform, ActionSheetController, NavParams } from '@ionic/angular';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as moment from 'moment';
/**
 * Services
 */
import { PouchService } from '../services/pouch-service';

@Component({
  selector: 'page-user-types',
  templateUrl: 'user-types.html',
  styleUrls: ['user-types.scss'],
  encapsulation: ViewEncapsulation.None,
  //providers: [NavParams]
})
export class UserTypesPage {
  navParams: any = {};
  @Input() mode: string = 'entity';
  ObjectKeys = Object.keys;
  @Input() ispage: boolean = true;
  permission_types = ['view', 'add', 'edit', 'delete', 'receive_payment'];
  @Output() toChange = new EventEmitter<any>();
  subscriptions: any = {};
  loading: any;
  customers = [];
  settings = [];
  pages = [];
  @Input() page;
  @Input() to_ward;
  @Input() usertype: any = {
    id: '',
    name: '',
  };
  @Input() setting;

  constructor(injector: Injector, private titleService: Title, public loadingCtrl: LoadingController, public http: HttpClient, public alertCtrl: AlertController, public _DomSanitizer: DomSanitizer, public toastController: ToastController, public modalCtrl: ModalController, public actionSheetCtrl: ActionSheetController, public platform: Platform, public db: PouchService, private router: Router) {
    let navParams2: any = {};
    if (router.url != '/UserTypesPage') {
      navParams2 = injector.get(NavParams);
    }
    this.navParams = this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras.state != undefined ? this.router.getCurrentNavigation().extras.state : navParams2.data;
    this.titleService.setTitle(`User Types - ${this.db.gsetting.username} - ${this.db.appinfo.title}`);
    this.usertype = this.navParams['entity'] != undefined ? this.navParams['entity'] : this.usertype;
    this.loadPages();
  }

  async loadPages() {
    this.pages = [
      ...this.db.pages,
      {
        name: 'Settings',
        icon: 'gear',
        type: 'page',
        route: '/SettingsPage',
        mode: 'settings',
      },
    ];
  }

  async addPermissionType(setting_id) {
    let alert = await this.alertCtrl.create({
      header: 'Add Permission Type',
      inputs: [
        {
          name: 'name',
          placeholder: 'Name',
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'Save',
          handler: (data) => {
            if (data.name != '') {
              this.usertype[setting_id][data.name] = true;
            }
          },
        },
      ],
    });
    alert.present();
  }

  ionViewWillLeave() {
    let subscriptions = Object.keys(this.subscriptions);
    subscriptions.map((subscription) => {
      this.subscriptions[subscription].unsubscribe();
    });
  }

  save() {
    if (this.usertype.id == '') {
      // replace spaces with underscore
      this.usertype.id = this.usertype.name.replace(/\s/g, '_');
    }
    this.db.update(this.usertype, 'usertype').then((res) => {
      if (this.db.user.usertype) {
        this.db.get(this.db.user.usertype, 'usertype').then((res) => {
          if (res != null) {
            this.db.user_roles = res;
          }
        });
      }
      this.dismiss(this.usertype);
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    Object.keys(changes).map((key) => {
      if (changes[key].currentValue != undefined) {
        this[key] = changes[key].currentValue;
        this.navParams[key] = changes[key].currentValue;
      }
    });
    this.ngOnInit();
  }

  ngOnInit() {
    let credentials = JSON.parse(localStorage.getItem(this.db.appinfo.product + '_credentials'));
    this.subscriptions.setting = this.db.getAllRx('setting').subscribe((settings) => {
      settings = settings.filter((setting) => setting.id != credentials.user_id);
      this.settings = settings;
      this.arrayinputformatter(this.setting);
    }); // none
  }

  arrayinputformatter(item) {
    let value = '';
    if (item != undefined) {
      if (item.id != undefined) {
        value += item.id;
      }
    }
    return value;
  }

  arraylistformatter(item) {
    let value = '';
    if (item != undefined) {
      if (item.id != undefined) {
        value += item.id;
      }
    }
    // capitalize first letter
    value = value.charAt(0).toUpperCase() + value.slice(1);
    return value;
  }

  pageinputformatter(item) {
    let value = '';
    if (item != undefined) {
      if (item.name != undefined) {
        value += item.name;
      }
    }
    return value;
  }

  selectItem(val, type) {
    this[type] = val;
    if (type == 'setting') {
      if (this.usertype[val.id] == undefined) {
        this.usertype[val.id] = {};
        this.permission_types.map((permission) => {
          if (permission != 'receive_payment' || val.id == 'income' || val.id == 'expense') {
            this.usertype[val.id][permission] = true;
          }
        });
      }
    } else if (type == 'page') {
      if (this.usertype.pages == undefined) {
        this.usertype.pages = {};
      }
      if (this.usertype.pages[val.route] === undefined) {
        this.usertype.pages[val.route] = true;
      }
    }
  }

  async presentToast(message, type = 'toast-success') {
    const toast = await this.toastController.create({
      message: message,
      duration: 4000,
      cssClass: type,
    });
    toast.present();
  }

  dismiss(entity) {
    if (this.ispage) {
      this.modalCtrl.dismiss(entity);
    } else {
      this.presentToast('Item was saved Successfully', 'toast-success');
    }
  }

  cancel() {
    //cancel action
    this.modalCtrl.dismiss();
  }

  back() {
    //this.navCtrl.pop();
  }

  help(page) {
    window.open('https://sarutech.com/documentation/' + page);
  }
}
